'use strict';


module.exports = Odigeo.Model.extend({
    defaults: {
        selectedDate: null,
    },
});
